var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEnlarge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.16675 10.6668V13.3335C2.16675 13.6096 2.39061 13.8335 2.66675 13.8335H5.33341C5.60956 13.8335 5.83341 13.6096 5.83341 13.3335C5.83341 13.0574 5.60956 12.8335 5.33341 12.8335H3.87385L7.0203 9.68705C7.21556 9.49179 7.21556 9.1752 7.0203 8.97994C6.82504 8.78468 6.50846 8.78468 6.31319 8.97994L3.16675 12.1264V10.6668C3.16675 10.3907 2.94289 10.1668 2.66675 10.1668C2.39061 10.1668 2.16675 10.3907 2.16675 10.6668ZM8.97986 6.31328C8.7846 6.50854 8.7846 6.82512 8.97986 7.02038C9.17512 7.21565 9.49171 7.21565 9.68697 7.02038L12.8334 3.87394V5.3335C12.8334 5.60964 13.0573 5.8335 13.3334 5.8335C13.6096 5.8335 13.8334 5.60964 13.8334 5.3335V2.66683C13.8334 2.39069 13.6096 2.16683 13.3334 2.16683H10.6667C10.3906 2.16683 10.1667 2.39069 10.1667 2.66683C10.1667 2.94297 10.3906 3.16683 10.6667 3.16683H12.1263L8.97986 6.31328Z",
    fill: "#2B2B35"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnlarge);
export default __webpack_public_path__ + "static/media/enlarge.7d14e5c0ce2489b161bdd37cfb707830.svg";
export { ForwardRef as ReactComponent };